/**
 * Utilidad para manejar errores de API de forma consistente
 * Maneja tanto errores de validación de Pydantic (arrays) como mensajes de error simples
 */

/**
 * Extrae un mensaje de error legible de la respuesta de error de Axios
 * @param {Error} error - El objeto de error de Axios
 * @param {string} defaultMessage - Mensaje por defecto si no se puede extraer el error
 * @returns {string} - Mensaje de error formateado
 */
export const getErrorMessage = (error, defaultMessage = 'Ha ocurrido un error') => {
  if (!error.response?.data?.detail) {
    return defaultMessage;
  }

  const detail = error.response.data.detail;

  // Si detail es un array (errores de validación de Pydantic)
  if (Array.isArray(detail)) {
    const errorMessages = detail.map(err => {
      const field = err.loc ? err.loc.join(' > ') : 'Campo desconocido';
      return `${field}: ${err.msg}`;
    }).join('\n');
    return `Errores de validación:\n${errorMessages}`;
  }

  // Si detail es un string simple
  if (typeof detail === 'string') {
    return detail;
  }

  // Si detail es un objeto, intentar convertirlo a string
  try {
    return JSON.stringify(detail);
  } catch {
    return defaultMessage;
  }
};

/**
 * Maneja un error y muestra un mensaje con toast
 * @param {Error} error - El objeto de error de Axios
 * @param {Function} toastError - Función toast.error
 * @param {string} defaultMessage - Mensaje por defecto
 */
export const handleApiError = (error, toastError, defaultMessage = 'Ha ocurrido un error') => {
  console.error('API Error:', error);
  const message = getErrorMessage(error, defaultMessage);
  toastError(message);
};
